const education = {
  title: 'Education',
  data: [
    {
      nama: 'Dian Nuswantoro University',
      study: 'Bachelor of Computer Science',
      description:
        'Activities and societies: Focus on computer science, create web and mobile applications, become a laboratory assistant, and administrator of the Dian Nuswantoro Club.',
      date: {
        start: '2019',
        end: '2023'
      },
      activities: [
        'GPA 3.74',
        'Completed web training through Dian Nuswantoro Computer CLub',
        'Became a laboratory assistant for the programming class at Dian Nuswantoro Programming Laboratory',
        'Became an Activity Manager at Dian Nuswantoro Computer Club (DNCC) for the 2020-2021 period',
        'Became a committee member of the Dinacom 2021 event',
        'Completed "Studi Independen" Kampus Merdeka program for 1 semester with role as a Frontend Engineer',
        'Completed Certified Internship Kampus Merdeka program for 1 semester with role as a Fullstack Developer'
      ]
    }
  ]
}

export default education
